<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ matchedDetLabel.lastMatchedDate }}</v-subheader>
        <span class="queryValue">{{ objData.lastMatchedDate }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ matchedDetLabel.lastBaseTranType }}</v-subheader>
        <span class="queryValue">{{ objData.lastBaseTranType }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ matchedDetLabel.bchMatchDocNo }}</v-subheader>
        <span class="queryValue">{{ objData.bchMatchDocNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ matchedDetLabel.bchMatchLater }}</v-subheader>
        <span class="queryValue">{{ objData.bchMatchLater }}</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      matchedDetLabel: {
        lastMatchedDate: 'Last Matched Date',
        lastBaseTranType: 'Last Base Transaction Type',
        bchMatchDocNo: 'Batch Match Document',
        bchMatchLater: 'Batch Match Later'
      }
    }
  },
  mounted() {},
  methods: {},
  props: {
    objData: {
      type: Object,
      default: null
    }
  },
  computed: {}
}
</script>
